exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".appointment-scheduler {\n  -webkit-transition: right 500ms cubic-bezier(0.19, 1, 0.22, 1);\n  transition: right 500ms cubic-bezier(0.19, 1, 0.22, 1); }\n  .appointment-scheduler .b-content {\n    -webkit-transition: opacity 700ms cubic-bezier(0.19, 1, 0.22, 1);\n    transition: opacity 700ms cubic-bezier(0.19, 1, 0.22, 1);\n    opacity: 0; }\n  .appointment-scheduler.expanded {\n    right: 0; }\n  .appointment-scheduler.expanded .b-content {\n      opacity: 1; }\n  .appointment-scheduler.collapsed {\n    right: -360px; }\n  .appointment-scheduler:not(.expanded):hover {\n    right: -350px; }\n  @media (max-width: 767px) {\n    .appointment-scheduler:not(.expanded):hover {\n      right: -360px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"config":{"path":"postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js!./Src/Shared/AppointmentScheduler/Animations.scss
// module id = 332
// module chunks = 6